import * as React from 'react';

import { compose, mapProps } from 'recompose';

import { FormattedMessage } from 'js/lib/coursera.react-intl';
import waitFor from 'js/lib/waitFor';

import withEnrollment from 'bundles/enroll/components/xdp/withEnrollment';
import type { PropsFromWithEnrollment } from 'bundles/enroll/components/xdp/withEnrollment';
import Naptime from 'bundles/naptimejs';
import ProductPricesV3 from 'bundles/naptimejs/resources/productPrices.v3';
import ReactPriceDisplay from 'bundles/payments-common/components/ReactPriceDisplay';
import PaymentChoice from 'bundles/s12n-enroll/components/bulk-pay/PaymentChoice';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/s12n-enroll';

import 'css!./__styles__/PaymentChoiceCapstone';

type PropsFromCaller = {
  courseId: string;
};

type PropsFromNaptime = {
  productPrices?: ProductPricesV3[];
};

type PropsFromWithProps = {
  productPrice?: ProductPricesV3;
};

type PropsFromWaitFor = Required<PropsFromWithProps> & Required<PropsFromWithEnrollment>;

type PropsToComponent = PropsFromCaller & PropsFromWaitFor;

class PaymentChoiceCapstone extends React.Component<PropsToComponent> {
  render() {
    const { enrollmentAvailableChoices, productPrice } = this.props;

    const title = (
      <FormattedMessage
        message={_t('Capstone • {price}')}
        price={<ReactPriceDisplay value={productPrice.amount} currency={productPrice.currencyCode} />}
      />
    );

    return (
      <TrackedDiv trackingName="s12n_enroll_modal_capstone_choice" withVisibilityTracking className="rc-PaymentChoiceCapstone">
        <PaymentChoice type="single" currentType="single" title={title}>
          <span>
            {_t(
              `Pay for the final course in the Specialization. When you complete the Capstone you'll earn a
            Specialization Certificate.`
            )}
          </span>
          {enrollmentAvailableChoices.isCapstoneAccessLocked && (
            <div className="ineligible-message">
              {_t(
                `You can pay for the Capstone now, but you cannot enroll until you have successfully
completed all other courses in the Specialization.`
              )}
            </div>
          )}
        </PaymentChoice>
      </TrackedDiv>
    );
  }
}

export default compose<PropsToComponent, PropsFromCaller>(
  Naptime.createContainer<PropsFromNaptime, PropsFromCaller>(({ courseId }) => ({
    productPrices: ProductPricesV3.deduceProductTypeAndGetProductPrices({ courseId }),
  })),
  withEnrollment<PropsFromCaller>(),
  mapProps<PropsFromWithProps, PropsFromNaptime>(({ productPrices, ...props }) => ({
    productPrice: productPrices?.[0],
    ...props,
  })),
  waitFor<PropsFromWithProps & PropsFromWithEnrollment>(
    ({ productPrice, enrollmentAvailableChoices }) => enrollmentAvailableChoices && productPrice
  )
)(PaymentChoiceCapstone);
